import Component from '@glimmer/component'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import type { TOC } from '@ember/component/template-only'
import { on } from '@ember/modifier'
import { fn } from '@ember/helper'
import { add } from 'date-fns'
import { t, formatDate } from 'ember-intl'

interface Signature {
  Element: HTMLDivElement
  Args: {
    center: Date
    onCenterChange: (date: Date) => unknown
    centerNext?: Date
  }
}

export class CalendarNav extends Component<Signature> {
  moveMonth = (months: number) => {
    this.args.onCenterChange(add(this.args.center, { months }))
  }

  <template>
    <div data-test-calendar-nav class="flex items-center justify-between gap-4" ...attributes>
      <MonthNavButton aria-label={{t "previousMonth"}} {{on "click" (fn this.moveMonth -1)}}>
        <PhosphorIcon @icon="phosphor-caret-left-bold" />
      </MonthNavButton>
      <div data-test-center class="grow text-center text-sm font-semibold">{{formatDate
          @center
          month="short"
          year="numeric"
        }}</div>
      {{#if @centerNext}}
        {{! hidden buttons to help with centering/balancing of the month labels }}
        <MonthNavButton aria-hidden="true" class="invisible"><PhosphorIcon
            @icon="phosphor-caret-right-bold"
          /></MonthNavButton>
        <MonthNavButton aria-hidden="true" class="invisible"><PhosphorIcon
            @icon="phosphor-caret-left-bold"
          /></MonthNavButton>
        <div data-test-center-next class="grow text-center text-sm font-semibold">{{formatDate
            @centerNext
            month="short"
            year="numeric"
          }}</div>
      {{/if}}
      <MonthNavButton aria-label={{t "nextMonth"}} {{on "click" (fn this.moveMonth 1)}}>
        <PhosphorIcon @icon="phosphor-caret-right-bold" />
      </MonthNavButton>
    </div>
  </template>
}

const MonthNavButton: TOC<{ Element: HTMLButtonElement; Blocks: { default: [] } }> = <template>
  <button
    type="button"
    class="hover:bg-neutral-75 rounded-lg px-4 py-2 transition-colors duration-300 ease-in-out active:bg-neutral-100"
    ...attributes
  >
    {{yield}}
  </button>
</template>
